// extracted by mini-css-extract-plugin
export default {"container":"legislation_date_picker-module__container--oM-Sk","text":"legislation_date_picker-module__text--XCNbQ"};